import Layout from "../../components/layout";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import nextI18NextConfig from "../../next-i18next.config";
import { GetStaticProps } from "next";
import Link from "next/link";
import CardWithIcon from "../../components/v2/cards/card-with-icon";
import VendorComparisons from "../../components/v2/comparison/vendor-comparisons";
import { AIAlertIconDark, AIDashboardIconDark, AIK8sRootIconDark, AutoFixIconDark, OpsAIDarkIcon } from "../../components/v2/icons-v2";
import "../../styles/scss/solutions.module.scss";
import "../../styles/scss/comparison.module.scss";
import CallToActionSmall from "../../components/v2/call-to-action-sm";

export default function Comparison({ }) {


  return (
      <Layout
        isHomePage={false}
        pageTitle={
          "Compare Observability Tools | Middleware Comparison Hub"
        }
        ogImage={"/images/comparison/comparison-og.webp"}
        uri={"/comparison/"}
        metaTitle={
          "Compare Observability Tools | Middleware Comparison Hub"
        }
        metaDesc={
          "Compare Middleware with leading observability platforms. Explore Datadog, New Relic, Dynatrace, Grafana, Coralogix, and more in one place."
        }
        metaRobotsNoindex={"index"}
        metaRobotsNofollow={"follow"}
      >
        <section className={`hero-section product-page comparison-main-page`}>
                <div className={'container'}>
                    <div className={"d-flex"}>
                        <div className={"left-block"}>
                            <div className={"hero-child"}>
                                <h1>Compare <span>Middleware</span> with leading observability platforms</h1>
                                <p>Evaluate pricing, features, AI capabilities, and deployment across today's leading observability platforms.</p>
                                <div className="d-flex">
                                        <Link
                                            href="/demo-request/"
                                            target="_blank"
                                            className="sign-up ahref-btn primary"
                                        >
                                            Request a Demo
                                        </Link>

                                        <Link
                                            href="#vendor-comparisons"
                                            className="sign-up ahref-btn secondary"
                                        >
                                            See Comparison
                                        </Link>
                                    </div>
                            </div>
                        </div>
                        <div className={"right-block"}>
                            <img
                                    className="product-hero-lcp"
                                    src={"/images/comparison.svg"}
                                    alt={""}
                                    width={1548}
                                    height={1180}
                                    fetchPriority="high"
                                    loading="eager"
                                    decoding="sync"
                                />

                        </div>
                    </div>
                </div>
            </section>

            <section className="ai-native-features comparison-features">
                        <div className="container">
                          <h2>The first observability platform built around AI, <br />
                            not bolted onto it</h2>
            
                          <section className={'mw-card career'}>
                            <div className={'d-flex card-items'}>
                              <CardWithIcon
                                icon={<AIDashboardIconDark />}
                                title={"AI Dashboards"}
                                description={
                                  "Describe what you want in plain English. Middleware builds the dashboard, selects the charts, and writes the queries. No PromQL, no custom query language, and no template gallery to comb through."
                                }
                              />
                              <CardWithIcon
                                icon={<AIAlertIconDark />}
                                title={"AI Alerts"}
                                description={
                                  "Alerts that learn what 'normal' looks like for each service and surface only the deviations that matter. Anomaly detection that doesn't drown your on-call team in noise."
                                }
                              />
                              <CardWithIcon
                                icon={<OpsAIDarkIcon />}
                                title={"OpsAI · SRE Agent"}
                                description={
                                  "An AI SRE that pinpoints root cause, identifies the offending line of code, and opens a pull request with the fix while you're still reading the alert. Auto-resolves issues with 50%+ accuracy internally, and 70%+ across beta customers."
                                }
                              />
                              <CardWithIcon
                                icon={<AIK8sRootIconDark />}
                                title={"AI K8s Root Cause Finder"}
                                description={
                                  "Auto-structuring, severity detection, and pattern recognition built into log ingestion. No manual regular expressions, no parsing pipelines to maintain."
                                }
                              />
                              <CardWithIcon
                                icon={<AutoFixIconDark />}
                                title={"Auto-Fix · On-call productivity up 80%+"}
                                description={
                                  "Auto-fix issues across infrastructure and application layers. Engineers see an 80%+ improvement in on-call productivity — and spend more time shipping products."
                                }
                              />
            
                            </div>
                          </section>
                        </div>
                      </section>
                      <VendorComparisons />
                      <CallToActionSmall />
      </Layout>
  );
}

export const getStaticProps: GetStaticProps = async (ctx) => {
  const translations = await serverSideTranslations(
    ctx?.locale ?? "en",
    ["common", "header", "footer"],
    nextI18NextConfig,
  );
  return {
    props: {
      ...translations,
      pageTitle: "Compare Observability Tools | Middleware Comparison Hub",
      description: "Compare Middleware with leading observability platforms. Explore Datadog, New Relic, Dynatrace, Grafana, Coralogix, and more in one place.",
      ogImage: "/images/comparison/comparison-og.webp",
      uri: "/comparison/",
      metaTitle: "Compare Observability Tools | Middleware Comparison Hub",
      metaDesc: "Compare Middleware with leading observability platforms. Explore Datadog, New Relic, Dynatrace, Grafana, Coralogix, and more in one place.",
      metaRobotsNoindex: "index",
      metaRobotsNofollow: "follow",
    },
  }
}
